import httpClient from "@/API/HttpClient";

// Language
const getActiveLanguages = () => httpClient.get(`api/language/active`);

// Login
const getOTP = (phone) => httpClient.post('api/otp', {phone});
const login = (phone, password) => httpClient.post(`api/login`, {phone, password});
const postFCMToken = (fcm_token) => httpClient.post(`api/user/fcm_token`, {fcm_token});

// Profile
const getUser = () => httpClient.get(`api/user`);
const getServiceRequests = () => httpClient.get(`api/user/service_request`);
const getOrders = () => httpClient.get(`api/user/order`);
const getOrderDetail = (id) => httpClient.get(`api/user/order/${id}`);
const getOrderRePayment = (id) => httpClient.get(`api/user/order/${id}/rePayment`);
const getUserCredit = (roomcode, mobile) => httpClient.get(`api/user/credit`, {params: {roomcode, mobile}});

// Type = [service, restaurant, shop, caffe]
const getCategories = (type) => httpClient.get(`api/category?type=${type}`);
const getCategoryProducts = (id) => httpClient.get(`api/category/${id}`);

const postServiceRequest = (serviceRequest) => httpClient.post(`api/service_request`, {...serviceRequest});
const postOrderProducts = (order) => httpClient.post(`api/order_products`, order);

const getHomepage = () => httpClient.get(`api/homepage`);
const getSurveyQuestions = () => httpClient.get(`api/survey-question`);
const createSurvey = (survey) => httpClient.post(`api/survey`, survey);

export {
    getActiveLanguages,
    getOTP,
    login,
    postFCMToken,
    getUser,
    getServiceRequests,
    getOrders,
    getOrderDetail,
    getOrderRePayment,
    getCategories,
    getCategoryProducts,
    postServiceRequest,
    postOrderProducts,
    getSurveyQuestions,
    createSurvey,
    getHomepage,
    getUserCredit
}
